// Button.jsx
import React from "react";
import "../Button.css";

const Button = ({ label = "Click Me", onClick, Icon, iconProps = {}, className = "", style = {}, type = 'primary', ...props }) => {
    return (
        <button className={`button ${className}`} onClick={onClick} style={style} {...props}>
            {Icon && <Icon className="button-icon" {...iconProps} />}
            <span className="button-label">{label}</span>
        </button>
    );
};


export default Button;